import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, UrlTree } from '@angular/router';
import { User } from '@app/models';
import { AuthService } from '@auth0/auth0-angular';
import { InjectionTokens } from '@src/serviceTokens';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { LoginService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class RoleTypeGuard {
  protected login: LoginService = inject(InjectionTokens.get(LoginService));

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.login.checkAuth$.pipe(
      switchMap(val => {
        return val ? this.auth.user$ : of(false);
      }),
      map((_user: User) => {
        const allowedRoles: string[] = route.data['allowedRoles'];
        for (let i = 0; i < allowedRoles.length; i++) {
          switch (allowedRoles[i]) {
            case 'vendor':
              if (this.login.isVendor) return true;
              break;
            case 'agency':
              if (this.login.isAgency) return true;
              break;
            case 'qbat':
              if (this.login.isQbat) return true;
              break;
            case 'colbi':
              if (this.login.isColbi) return true;
              break;
          }
        }

        const home: string = this.login.isQbat
          ? '/qbat/prequalification'
          : this.login.isAgency
            ? '/agency'
            : this.login.isVendor
              ? '/vendor'
              : '/';
        this.router.navigate([home]);
        console.log('This role does not have access to this page');
        return false;
      })
    );
  }

  canLoad(route: Route): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(route as ActivatedRouteSnapshot).pipe(
      tap(val => {
        if (!val) {
          this.router.navigate(['/']);
        }
      })
    );
  }
}
